module.exports = __webpack_public_path__ + "static/wu-tang-bd837fcae196a0b6159a802fe8eac336.jpeg";